import React, { ReactNode } from "react";
import ChevronUpIcon from "@/v2-components/core/icon/chevron-up-icon";
import { useTrans } from "@/utils/useTrans";
import { SUPPORT_SLIDE_ZINDEX } from "@/v2-components/pages/support/constants/support-slide-constants";
import { cn } from "@/libs/utils";

interface HelpCenterMobileSlideHeaderProps {
  slideStandardRef: React.RefObject<HTMLDivElement | null> | null; //slide 위치 기준 ref
  slideOpen: boolean;
  setSlideOpen: () => void;
  title: string;
  contents?: ReactNode;
  className?: string;
}

export const SupportHeaderSlideFixContents = ({
  slideStandardRef,
  slideOpen,
  setSlideOpen,
  title,
  contents,
  className,
}: HelpCenterMobileSlideHeaderProps) => {
  const { t } = useTrans(["support"]);

  return (
    <div
      ref={slideStandardRef}
      onClick={setSlideOpen}
      className={cn(
        "flex h-[56px] w-full items-center bg-white p-4 text-base smd:hidden",
        className,
        SUPPORT_SLIDE_ZINDEX["header"],
      )}
    >
      {t(title)}
      <span
        onClick={setSlideOpen}
        className={`ml-2 flex-shrink-0 transition-transform ${slideOpen ? "rotate-0" : "rotate-180"}`}
      >
        <ChevronUpIcon />
      </span>
      {contents && contents}
    </div>
  );
};
